<template>
    <form-view class="vote-service-detail-view">
        <template slot="field">
            <veui-field label="应用名称：">
                <veui-span>{{ store.serviceDetail.appName }}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{ store.serviceDetail.name }}</veui-span>
            </veui-field>
            <veui-field label="authKey：">
                <veui-span>{{ authKey }}</veui-span>
            </veui-field>
            <veui-field label="activityId：">
                <veui-span>{{ activityId }}</veui-span>
            </veui-field>
            <veui-field label="投票类型：">
                <veui-span>{{ store.voteTypeMap[store.serviceDetail.rangeType] }}：</veui-span>
                <veui-span>{{ store.serviceDetail.rangeMin }} - {{ store.serviceDetail.rangeMax }}</veui-span>
            </veui-field>
            <veui-field label="投票选项：">
                <veui-textarea
                    readonly
                    v-model="store.serviceDetail.options"/>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import DetailModel from './DetailModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Span, Textarea} from 'veui';
import serviceMixin from '@/common/mixins/service';


export default createView(FormView, DetailModel, {
    name: 'VoteServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-span': Span,
        'veui-textarea': Textarea,
        'veui-button': Button
    },
    mixins: [serviceMixin]
});
</script>
